import { render } from "./private-sale.vue?vue&type=template&id=3c457e47"
import script from "./private-sale.vue?vue&type=script&lang=js"
export * from "./private-sale.vue?vue&type=script&lang=js"

import "./private-sale.vue?vue&type=style&index=0&id=3c457e47&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__